export const SET_EVENT_TICKET = 'SET_EVENT_TICKET'
